export const getHostname = () => process.env.HOSTNAME || window.location.origin;

export const getImageBaseUrl = () => process.env.HOSTNAME || '';

export const getApiEntrypoint = () => {
  const rootEl = document.getElementById('purchase-intent-form');
  const { apiEntrypoint } = rootEl.dataset;

  return apiEntrypoint;
};

const request = async (url, options, absolute = false) => {
  const res = await fetch((absolute ? '' : getHostname()) + url, options);
  if (!res.ok) {
    throw new Error(`${res.status} ${res.statusText}`);
  }

  const data = res.status === 204 ? null : await res.json();

  const headers = {};
  for (const [headerName, headerValue] of res.headers.entries()) {
    headers[headerName] = headerValue;
  }

  if (headers['x-total-count']) {
    headers['x-total-count'] = parseInt(headers['x-total-count'], 10);
  }

  return {
    headers: {
      get: headerName => headers[headerName.toLowerCase()],
    },
    data,
  };
};

export default request;
